import { combineEpics, Epic, ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'

import { AppProviders } from '../../app.module'

import RouterActions, { NAVIGATE, REDIRECT, RELOAD } from './router.actions'

const router: Epic<RouterActions, any, AppProviders> = (action$, _, { routerService }) => {
  return action$.pipe(
    ofType(NAVIGATE, REDIRECT, RELOAD),
    tap((action) => {
      if (action.type === NAVIGATE) {
        routerService.navigateTo(action.payload)
      }

      if (action.type === REDIRECT) {
        routerService.redirectTo(action.payload)
      }

      if (action.type === RELOAD) {
        routerService.reload()
      }
    }),
    ignoreElements()
  )
}

export default combineEpics(router)



// WEBPACK FOOTER //
// ./src/app/core/store/router.epics.ts